import { Box,Button, MenuItem, Select,TextField, useTheme, InputAdornment, alpha,styled, SelectChangeEvent,} from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import React from 'react';
import { AutoCompleteParceiroListagem } from '../../forms';
import { Environment } from '../../environment';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import AddIcon from '@mui/icons-material/Add';
import EventIcon from '@mui/icons-material/Event';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

interface IDadosSelect {
  nameBD: string;
  descricao: string;
}
interface IFerramentasDaListagemProps {
  dadosSelecao?: IDadosSelect[];
  dataInicial?: string;
  dataFinal?: string;
  textonome?: string;
  mostrarInputData?: boolean;
  aoMudarDataInicial?: (novoTexto: string) => void;
  aoMudarDataFinal?: (novoTexto: string) => void;
  textoBotaoNovo?: string;
  mostrarBotaoNovo?: boolean;
  aoClicarEmNovo?: () => void;
  mostrarInputBasicSelect?: boolean;
  textoDoSelect?: string;
  aoMudarTextoDoSelect?: (novoTextoselect: string) => void;
  mostrarInputBusca?: boolean;
  textoDaBusca?: string;
  aoMudarTextoDeBusca?: (novoTexto: string) => void;
  mostrarAutoComplete?: boolean;
  aoMudarTextoDoParceiro?: (novoTextoselect: string, texto1: string) => void;
}
const StyledSelect = styled(Select<string>)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.spacing(1),
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: alpha(theme.palette.primary.main, 0.3),
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.primary.main,
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.primary.main,
    borderWidth: 1,
  },
}));
const StyledTextField = styled(TextField)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.spacing(1),
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: alpha(theme.palette.primary.main, 0.3),
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.primary.main,
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.primary.main,
    borderWidth: 1,
  },
}));
const StyledDatePicker = styled(DatePicker<Dayjs>)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(1),
    '& fieldset': {
      borderColor: alpha(theme.palette.primary.main, 0.3),
    },
    '&:hover fieldset': {
      borderColor: theme.palette.primary.main,
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.primary.main,
      borderWidth: 1,
    },
  },
}));

export const FerramentasDaListagemEntrada: React.FC<IFerramentasDaListagemProps> = ({
  textoDaBusca = '',
  textonome = '',
  dataInicial = '',
  aoMudarDataInicial,
  dataFinal = '',
  aoMudarDataFinal,
  mostrarInputData = false,
  aoClicarEmNovo,
  textoBotaoNovo = 'Novo',
  mostrarBotaoNovo = true,
  dadosSelecao = [],
  mostrarInputBasicSelect = false,
  textoDoSelect = '',
  aoMudarTextoDoSelect,
  mostrarInputBusca = false,
  aoMudarTextoDeBusca,
  mostrarAutoComplete = false,
  aoMudarTextoDoParceiro,
}) => {
  const theme = useTheme();

  const formatDateForPicker = (dateString: string) => {
    if (!dateString) return null;

    const partes = dateString.split('/');
    if (partes.length !== 3) return null;

    try {
      return dayjs(`${partes[2]}-${partes[1]}-${partes[0]}`);
    } catch {
      return null;
    }
  };

  const dataInicialFormatada = formatDateForPicker(dataInicial);
  const dataFinalFormatada = formatDateForPicker(dataFinal);

  const handleuuidparceiroNome = (nome: string | undefined) => {
    if (nome != null) {
      // Esta função parece não estar sendo usada corretamente
      // textonome é uma prop, não pode ser reassinada
      // Provavelmente precisa ser repensada essa lógica
    }
  };

  const handleuuidparceiro = (uuid: string | undefined) => {
    if (uuid != null && aoMudarTextoDoParceiro) {
      aoMudarTextoDoParceiro(uuid, textonome || '');
    }
  };

  const handleSelectChange = (event: SelectChangeEvent<string>) => {
    aoMudarTextoDoSelect?.(event.target.value);
  };

  const handleDateChange = (
    date: Dayjs | null,
    callback?: (value: string) => void
  ) => {
    if (!date || !date.isValid()) return;

    callback?.(date.format('DD/MM/YYYY'));
  };
  return (
    <Box
      gap={2}
      marginX={1}
      marginBottom={2}
      padding={2}
      display="flex"
      alignItems="center"
      borderRadius={1}
      boxShadow={1}
      sx={{
        backgroundColor: 'background.paper',
        border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
        flexWrap: 'wrap',
      }}
    >
      {mostrarInputBasicSelect && (
        <Box sx={{ minWidth: { xs: '100%', sm: 180 } }}>
          <StyledSelect
            fullWidth
            size="small"
            value={textoDoSelect}
            onChange={handleSelectChange}
            startAdornment={
              <InputAdornment position="start" sx={{ ml: 1 }}>
                <FilterListIcon fontSize="small" color="action" />
              </InputAdornment>
            }
          >
            {dadosSelecao.map((item) => (
              <MenuItem key={item.nameBD} value={item.nameBD}>
                {item.descricao}
              </MenuItem>
            ))}
          </StyledSelect>
        </Box>
      )}
      {mostrarInputBusca && (
        <Box sx={{ minWidth: { xs: '100%', sm: 250 } }}>
          <StyledTextField
            size="small"
            value={textoDaBusca}
            placeholder={Environment.INPUT_DE_BUSCA}
            onChange={(e) => aoMudarTextoDeBusca?.(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" color="action" />
                </InputAdornment>
              ),
            }}
          />
        </Box>
      )}
      {mostrarAutoComplete && (
        <Box sx={{ minWidth: { xs: '100%', sm: 350 } }}>
          <AutoCompleteParceiroListagem
            nome={handleuuidparceiroNome}
            uuidparceiro={handleuuidparceiro}
            isExternalLoading={false}
          />
        </Box>
      )}
      {mostrarInputData && (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Box display="flex" gap={1} alignItems="flex-end">
            <Box>
              <StyledDatePicker
                sx={{ minWidth: 150, '& .MuiInputAdornment-positionStart': { display: { xs: 'none', sm: 'flex' } } }}
                format='DD/MM/YYYY'
                value={dataInicialFormatada}
                onChange={(date) => handleDateChange(date, aoMudarDataInicial)}
                slotProps={{
                  textField: {
                    size: 'small',
                    InputProps: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <EventIcon fontSize="small" color="action" />
                        </InputAdornment>
                      ),
                    }
                  }
                }}
              />
            </Box>

            <Box>
              <StyledDatePicker
                sx={{ minWidth: 150, '& .MuiInputAdornment-positionStart': { display: { xs: 'none', sm: 'flex' } } }}
                format='DD/MM/YYYY'
                value={dataFinalFormatada}
                onChange={(date) => handleDateChange(date, aoMudarDataFinal)}
                slotProps={{
                  textField: {
                    size: 'small',
                    InputProps: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <CalendarTodayIcon fontSize="small" color="action" />
                        </InputAdornment>
                      ),
                    }
                  }
                }}
              />
            </Box>
          </Box>
        </LocalizationProvider>
      )}

      {/* Botão Novo */}
      <Box flex={1} display="flex" justifyContent="flex-end">
        {mostrarBotaoNovo && (
          <Button
            disableElevation
            variant="contained"
            onClick={aoClicarEmNovo}
            startIcon={<AddIcon />}
            sx={{
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 'medium',
              px: 3,
              py: 1,
            }}
          >
            {textoBotaoNovo}
          </Button>
        )}
      </Box>
    </Box>
  );
};